import type { AiDudeEnv, AiDudeQuery } from '@iac/contracts';
import { useDict } from '../../i18n/dictionary';
import { api } from '../../lib/api';
import {
  useCreateResource,
  useDeleteResource,
  useResourceQuery,
  useUpdateResource,
} from '../../lib/crud';
import { ag5Dict } from './i18n';

const LINKS = ['ag5', 'links'] as const;

export function useLinks() {
  const t = useDict(ag5Dict);
  return useResourceQuery(LINKS, api.ag5.listLinks, t.loadLinksFailed);
}

export function useCreateLink() {
  const t = useDict(ag5Dict);
  return useCreateResource(LINKS, api.ag5.createLink, t.addLinkFailed);
}

export function useUpdateLink() {
  const t = useDict(ag5Dict);
  return useUpdateResource(
    LINKS,
    api.ag5.updateLink,
    t.saveLinkFailed,
    t.linkSaved,
  );
}

export function useDeleteLink() {
  const t = useDict(ag5Dict);
  return useDeleteResource(LINKS, api.ag5.deleteLink, t.deleteLinkFailed);
}

export function useAiDudeEnvironments() {
  const t = useDict(ag5Dict);
  return useResourceQuery(
    ['ag5', 'ai-dude', 'environments'],
    api.ag5.listAiDudeEnvironments,
    t.loadEnvironmentsFailed,
  );
}

/** Probes AI Dude through our API; reachability is in the body, not the status. */
export function useAiDudeStatus(env: AiDudeEnv, query: AiDudeQuery) {
  const t = useDict(ag5Dict);
  return useResourceQuery(
    ['ag5', 'ai-dude', env, 'status', query],
    () => api.ag5.getAiDudeStatus({ params: { env }, query }),
    t.checkAiDudeFailed,
  );
}
